import { useEffect, Fragment } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { obtenerCliente, limpiarCliente } from '../../../actions/clientes';

const PerfilCliente = () => {

    let rutasBread = [
        {
            activo: false,
            nombre: 'Clientes',
            path: '/ingresos/clientes'
        },
        {
            activo: true,
            nombre: 'Perfil del cliente',
            path: '/ingresos/clientes/perfil/'
        }
    ];

    const dispatch = useDispatch();

    const { id } = useParams();

    const { detalles } = useSelector(state => state.clientes);

    const [clienteData, setClienteData] = useState({
        id: null,
        nombre: null, 
        apellido: null, 
        telefono: null, 
        celular: null, 
        correo: null, 
        calle: null, 
        numero_exterior: null, 
        numero_interior: null, 
        fraccionamiento: null, 
        codigo_postal: null, 
        municipio: null, 
        estado: null
    });

    /* Funciones generales */

    const convertFechaTiempo = (fecha) => {
        let mensaje = 'Sin definir';

        if(fecha && fecha != '0000-00-00'){
            let diferencia = Math.floor(new Date().getTime() - new Date(fecha).getTime());
            let cantidad_dia = 1000 * 60 * 60 * 24;

            let dias = Math.floor(diferencia / cantidad_dia);
            let meses = 0;
            let anos = 0;

            if(dias >= 365){
                anos = Math.floor(dias / 365);
                dias = dias - (anos * 365);
            }

            if(dias >= 30){
                meses = Math.floor(dias / 30);
                dias = dias - (meses * 30);
            }

            let texto_dias = dias + ' ' + (dias == 1 ? 'dia' : 'dias');
            let texto_meses = meses + ' ' + (meses == 1 ? 'mes' : 'meses');
            let texto_anos = anos + ' ' + (anos == 1 ? 'año' : 'años');

            mensaje = texto_anos + ' ' + texto_meses + ' ' + texto_dias;
        }

        return mensaje;
    }

    useEffect(() => {
        dispatch(limpiarCliente());

        return () => {
            dispatch(limpiarCliente());
        }
    }, []);

    useEffect(() => {
        if(id){
            dispatch(obtenerCliente(id));

            rutasBread[1].path = rutasBread[1].path + id;

            dispatch(editarBreadcrumb(rutasBread));
        }
    }, [id]);

    useEffect(() => {
        if(detalles){
            setClienteData({
                ...clienteData, 
                id: detalles.id, 
                nombre: detalles.nombre, 
                apellido: detalles.apellido, 
                telefono: detalles.telefono, 
                celular: detalles.celular, 
                correo: detalles.correo, 
                calle: detalles.calle, 
                numero_exterior: detalles.numero_exterior, 
                numero_interior: detalles.numero_interior, 
                fraccionamiento: detalles.fraccionamiento, 
                codigo_postal: detalles.codigo_postal, 
                municipio: detalles.municipio, 
                estado: detalles.estado
            });
        }
    }, [detalles]);

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-12 px-4 pb-4">
                    <h3 className="mb-3 mt-5">Perfil del cliente</h3>
                    
                    <div className="row mt-5 px-3">
                        <div className="col-md-3">
                            <label className="fw-bold">Nombre</label>
                            <p>{clienteData?.nombre || 'Sin definir'}</p>
                        </div>
                        <div className="col-md-3">
                            <label className="fw-bold">Apellido</label>
                            <p>{clienteData?.apellido || 'Sin definir'}</p>
                        </div>                        
                        <div className="col-md-2">
                            <label className="fw-bold">Teléfono</label>
                            <p>{clienteData?.telefono || 'Sin definir'}</p>
                        </div>
                        <div className="col-md-2">
                            <label className="fw-bold">Celular</label>
                            <p>{clienteData?.celular || 'Sin definir'}</p>
                        </div>
                        <div className="col-md-3">
                            <label className="fw-bold">Email</label>
                            <p>{clienteData?.correo || 'Sin definir'}</p>
                        </div>
                        <div className="col-md-5">
                            <label className="fw-bold">Calle</label>
                            <p>{clienteData?.calle || 'Sin definir'}</p>
                        </div>
                        <div className="col-md-3">
                            <label className="fw-bold">Número exterior</label>
                            <p>{clienteData?.numero_exterior || 'Sin definir'}</p>
                        </div>
                        <div className="col-md-3">
                            <label className="fw-bold">Número interior</label>
                            <p>{clienteData?.numero_interior || 'Sin definir'}</p>
                        </div>
                        <div className="col-md-3">
                            <label className="fw-bold">Fraccionamiento</label>
                            <p>{clienteData?.fraccionamiento || 'Sin definir'}</p>
                        </div>
                        <div className="col-md-2">
                            <label className="fw-bold">Código postal</label>
                            <p>{clienteData?.codigo_postal || 'Sin definir'}</p>
                        </div>
                        <div className="col-md-3">
                            <label className="fw-bold">Estado</label>
                            <p>{clienteData?.municipio || 'Sin definir'}</p>
                        </div>
                        <div className="col-md-2">
                            <label className="fw-bold">Municipio</label>
                            <p>{clienteData?.estado || 'Sin definir'}</p>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default PerfilCliente;